import { Chip, Typography } from '@material-ui/core';
import React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import {
  formatDuration,
  getPreviewThumbnail,
  IMatchVideo,
  MATCH_VIDEO_SOURCE_ADVERSPORT,
  MATCH_VIDEO_SOURCE_SCOREBAT,
  MATCH_VIDEO_SOURCE_YOUTUBE,
} from '../typings';

interface IProps extends Partial<InjectedIntlProps> {
  video: IMatchVideo;
}

// Chip colors per source: Adversport (human-managed) videos stand out, imported ones stay neutral.
export const SOURCE_CHIP_STYLES: Record<string, React.CSSProperties> = {
  [MATCH_VIDEO_SOURCE_ADVERSPORT]: { backgroundColor: '#1976d2', color: '#fff' },
  [MATCH_VIDEO_SOURCE_YOUTUBE]: { borderColor: '#9e9e9e', color: '#616161' },
  [MATCH_VIDEO_SOURCE_SCOREBAT]: { borderColor: '#9e9e9e', color: '#616161' },
};

// @ts-ignore
@injectIntl
export class SourceChip extends React.Component<{ source: string } & Partial<InjectedIntlProps>> {
  public render() {
    const { source } = this.props;
    const m = this.props.intl!.messages;

    return (
      <Chip
        size="small"
        variant={source === MATCH_VIDEO_SOURCE_ADVERSPORT ? 'default' : 'outlined'}
        label={m[`matchVideo_source_${source}`] || source}
        style={SOURCE_CHIP_STYLES[source] || SOURCE_CHIP_STYLES[MATCH_VIDEO_SOURCE_YOUTUBE]}
      />
    );
  }
}

// Read-only view of the metadata resolved from YouTube by the API.
// @ts-ignore
@injectIntl
export class MatchVideoCard extends React.Component<IProps> {
  public render() {
    const m = this.props.intl!.messages;
    const { video } = this.props;
    const thumbnail = getPreviewThumbnail(video);

    return (
      <div style={{ display: 'flex', gap: 16, padding: 16 }}>
        <a href={video.url.replace('/embed/', '/watch?v=')} target="_blank" rel="noopener noreferrer" style={{ flexShrink: 0 }}>
          {thumbnail ? (
            <img src={thumbnail.url} alt={video.originalTitle || video.title} style={{ width: 320, maxWidth: '100%', borderRadius: 4 }} />
          ) : (
            <div style={{ width: 320, height: 180, background: '#eee', borderRadius: 4 }} />
          )}
        </a>
        <div style={{ flex: 1, minWidth: 0 }}>
          <Typography variant="h6" gutterBottom>
            {video.originalTitle || video.title}
          </Typography>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
            <Chip size="small" label={video.title} />
            <SourceChip source={video.metaImportSource} />
            {video.isEmbeddable === false && (
              <Chip size="small" label={m.matchVideo_notEmbeddable} style={{ backgroundColor: '#f44336', color: '#fff' }} />
            )}
          </div>
          <Typography variant="body2" color="textSecondary">
            {m.field_duration} : {formatDuration(video.duration)}
            {video.sourcePublishedAt && ` · ${m.field_publishedAt} : ${new Date(video.sourcePublishedAt).toLocaleString()}`}
            {` · ${m.field_ordering} : ${video.ordering}`}
          </Typography>
          <Typography variant="body2" color="textSecondary" style={{ wordBreak: 'break-all' }}>
            <a href={video.url} target="_blank" rel="noopener noreferrer">
              {video.url}
            </a>
          </Typography>
          {video.originalDescription && (
            <Typography variant="body2" style={{ marginTop: 8, whiteSpace: 'pre-wrap', maxHeight: 120, overflow: 'auto' }}>
              {video.originalDescription}
            </Typography>
          )}
        </div>
      </div>
    );
  }
}
